module.exports = __webpack_public_path__ + "static/media/platoducha-white.c1acdbac.svg";